var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadrao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.67969V6.32031H9.17969V3H5.82031V6.32031H2.5V9.67969H5.82031V13H9.17969V9.67969H12.5ZM13.3203 0.5C13.763 0.5 14.1536 0.669271 14.4922 1.00781C14.8307 1.34635 15 1.73698 15 2.17969V13.8203C15 14.263 14.8307 14.6536 14.4922 14.9922C14.1536 15.3307 13.763 15.5 13.3203 15.5H1.67969C1.23698 15.5 0.846354 15.3307 0.507812 14.9922C0.169271 14.6536 0 14.263 0 13.8203V2.17969C0 1.73698 0.169271 1.34635 0.507812 1.00781C0.846354 0.669271 1.23698 0.5 1.67969 0.5H13.3203Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadrao);
export default __webpack_public_path__ + "static/media/padrao.ed20650b7838248b3a8edc4d135a2774.svg";
export { ForwardRef as ReactComponent };